import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from '@reduxjs/toolkit'
import {
  IMessageRecipient,
  RecipientTypeEnum,
} from 'Modules/Communication/shared/models/Inbox'
import { RootState } from 'shared/store/store'
import {
  handleRecipientModal,
  onRecipientsClose,
  resetListedRecipients,
} from '../recipients'
import { SystemState, getMessageRecipients } from '../recipients/selectors'

// @ts-expect-error todo
export const recipientsAdapter = createEntityAdapter<IMessageRecipient>({
  selectId: (recipient) => recipient.nameregisterId,
})

const toasterSlice = createSlice({
  name: 'message',
  initialState: recipientsAdapter.getInitialState(),
  reducers: {
    removeMessageRecipient: recipientsAdapter.removeOne,
    removeAllMessageRecipients: recipientsAdapter.removeAll,
  },
  extraReducers: (builder) => {
    builder.addCase(addMessageRecipients.fulfilled, (state, action) => {
      recipientsAdapter.addMany(state, action.payload)
    })
  },
})

const addMessageRecipients = createAsyncThunk<IMessageRecipient[]>(
  'message/addMessageRecipients',
  async (_args, { getState, dispatch }) => {
    const store = getState() as RootState
    // RootState.sendMessage.sms.message.from is IMessageUserModel; SystemState expects IMessageRecipient.
    // getMessageRecipients only reads state.sendMessage.recipients, so this cast is safe at runtime.
    const { listedRecipients } = getMessageRecipients(
      store as unknown as SystemState
    )

    const recipientsToAdd: IMessageRecipient[] = [...listedRecipients].map(
      (rec) => ({
        email: rec.email,
        name: rec.name,
        nameregisterId: rec.nameId,
        recipientType: RecipientTypeEnum.To,
        unitIds: rec.unitIds,
      })
    )

    dispatch(resetListedRecipients())
    dispatch(handleRecipientModal({ open: null, type: null }))
    dispatch(onRecipientsClose())

    return recipientsToAdd
  }
)

export const { reducer, actions } = toasterSlice
export { addMessageRecipients }
